import { CustomerProjectType } from './customer-project-type.enum';
import { CustomerProject } from './customer-project.interface';
import { Document } from './document';
import { Status } from './status.interface';
import { User } from './user.interface';
import { WorkareaImage } from './workarea-image';

export class Workarea {
    public id: number = null;
    public customer_id: number;
    public user_id: number;
    public user: User;
    public status_id: number;
    public number: number;
    public street: string;
    public zipcode: string;
    public housenumber: string;
    public place: string;
    public road_number: string;
    public lat: number;
    public lng: number;
    public comments: string;
    public feedback: string;
    public project_id: number;
    public extra: any = {};
    public areas: any = [];

    public status: Status;
    public status_name: string;
    public status_colorcode: string;

    public image: string;
    public images: Array<WorkareaImage> = [];

    public created_at: Date;
    public updated_at: Date;
    public deleted_at: Date;

    public documents: Document[];

    public has_documents: boolean;
    public type?: CustomerProjectType;
    public customer_project_id?: number;
    public customerProject?: CustomerProject;
    public geom_geojson?: any;
}

export const projectFitsWorkarea = (project: CustomerProject, workarea: Workarea): boolean =>
    (project.type === CustomerProjectType.drillings) === (workarea.type === CustomerProjectType.drillings);
